import { FaSoap, FaTshirt } from "react-icons/fa";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export default function DashboardCards({ index, title, value, change, positive ,icon }) {
  const Icon = icon || FaSoap;
  return (
    <div className="flex-1">
      {index % 2 === 0 ? (
        // Card 1: gradient with bubbles
        <div className="relative rounded-2xl overflow-hidden text-white p-4 bg-gradient-to-br from-[#3383B2] to-blue-500 shadow-lg h-36 flex flex-col">
          {/* Decorative bubbles */}
          <div className="absolute -top-4 -left-4 w-16 h-16 bg-white opacity-10 rounded-full"></div>
          <div className="absolute bottom-2 right-2 w-12 h-12 bg-white opacity-5 rounded-full"></div>
          <div className="absolute top-6 right-8 w-10 h-10 bg-white opacity-10 rounded-full"></div>
          <div className="absolute bottom-6 left-10 w-8 h-8 bg-white opacity-10 rounded-full"></div>

          {/* Content */}
          <div className="relative flex items-center space-x-2">
            <div className="flex items-center justify-center w-8 h-8 bg-white rounded-full">
              <Icon className="text-[#3383B2] text-sm" />
            </div>
            <div className="text-lg font-medium">{title}</div>
          </div>
          <div className="flex flex-col h-full justify-between mt-3">
            <div className="relative text-2xl font-semibold">
              {value} 
            </div>
            {change !== undefined && (
              <div
                className="relative flex items-center text-xs font-medium  py-0.5 text-white"
              >
                {positive ? (
                  <ArrowDropUpIcon fontSize="small" />
                ) : (
                  <ArrowDropDownIcon fontSize="small" />
                )}
                <span className="ml-0.5">{change}</span>
              </div>
            )}
          </div>
        </div>
      ) : (
        // Card 2: white with wave and bubbles
        <div className="relative rounded-2xl overflow-hidden bg-white p-4 shadow-md h-36 flex flex-col ">
          {/* Decorative shapes */}
          <div className="absolute -top-4 right-4 w-12 h-12 bg-[#3383B2]/10 rounded-full"></div>
          <div className="absolute bottom-0 left-0 w-full h-10 bg-gradient-to-t from-[#3383B2]/10 to-transparent"></div>
          <div className="absolute bottom-4 right-8 w-6 h-6 bg-[#3383B2]/10 rounded-full"></div>

          {/* Content */}
          <div className="relative flex items-center space-x-2">
            <div className="flex items-center justify-center w-8 h-8 bg-[#3383B2]/10 rounded-full">
              <Icon className="text-[#3383B2] text-sm" />
            </div>
            <div className="text-gray-700 text-lg font-medium">{title}</div>
          </div>

          <div className="flex flex-col h-full justify-between mt-3 ">
            <div className="relative text-2xl font-semibold ">
              {value} 
            </div>
            {change !== undefined && (
              <div
                className="relative flex items-center text-xs font-medium  py-0.5 text-black"
              >
                {positive ? (
                  <ArrowDropUpIcon fontSize="small" />
                ) : (
                  <ArrowDropDownIcon fontSize="small" />
                )}
                <span className="ml-0.5">{change}</span>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
